import { DASH } from "common/constants";
import { transformViewDate } from "utils/date-utils";

interface IColumn {
  id: string;
  title: string;
  field: string;
  renderer?: (value: string) => string;
}

export const columns: IColumn[] = [
  {
    id: "Risk",
    title: `Factor Type | Description`,
    field: "riskFactor.shortDescription"
  },
  {
    id: "DateOn",
    title: "Date On",
    field: "identifiedOn",
    renderer: val => (val ? transformViewDate(val) : DASH)
  },
  {
    id: "DateOff",
    title: "Date Off",
    field: "expiredOn",
    renderer: val => (val ? transformViewDate(val) : DASH)
  }
];
